import { render, staticRenderFns } from "./AnnotationEllipse.vue?vue&type=template&id=1ccdc680&"
import script from "./AnnotationEllipse.vue?vue&type=script&lang=js&"
export * from "./AnnotationEllipse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports